/*
 * Inside Your Kit — mobile tap-to-reveal item descriptions.
 * Carousel behaviour is handled by <story-carousel> (story-carousel.js).
 * Vanilla, scoped per grid so multiple instances don't affect each other.
 */
(function () {
  const MOBILE_BREAKPOINT = 990;

  document.addEventListener('click', (event) => {
    const item = event.target.closest('.inside-your-kit__item');
    if (!item) return;
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;

    const grid = item.closest('.inside-your-kit__grid');
    if (!grid) return;

    const wasActive = item.classList.contains('is-active');
    grid
      .querySelectorAll('.inside-your-kit__item.is-active')
      .forEach((el) => el.classList.remove('is-active'));

    if (!wasActive) item.classList.add('is-active');
  });
})();
